import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const getCheckboxOuterClassNames = disabled => (
  classNames('checkbox__outer', {
    'checkbox__outer--is-disabled': disabled,
  })
);

// istanbul ignore next
const Checkbox = ({
  extraClass = '',
  name,
  id,
  disabled = null,
  checked = null,
  required = false,
  onChange,
}) => (
  <div className={`checkbox ${extraClass}`}>
    <input
      className="checkbox__input"
      type="checkbox"
      name={name}
      id={id}
      disabled={disabled}
      checked={checked}
      required={required}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
      }}
    />
    <div className={getCheckboxOuterClassNames(disabled)} />
    <div className="checkbox__check" />
  </div>
);

Checkbox.propTypes = {
  extraClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

export default Checkbox;
